<div class="mb-2 accessibilityMessage">
    <p innerHTML="{{ 'footer.accessibility.message' | translate | async }}">
        {{ 'footer.accessibility.message' | translate | async }}
    </p>
</div>

<footer class="ontario-footer ontario-footer--default">
    <div class="ontario-row">
        <div class="ontario-columns ontario-small-12">
            <ul class="ontario-footer__links-container ontario-footer__links-container--inline">
                <li>
                    <a class="ontario-footer__link" href="https://www.ontario.ca/page/accessibility">
                        {{ 'footer.accessibility.link.text' | translate | async}}
                    </a>
                </li>
                <li>
                    <a class="ontario-footer__link" href="https://www.ontario.ca/page/privacy-statement">
                        {{ 'footer.privacy.link.text' | translate | async}}
                    </a>
                </li>
                <li>
                    <a class="ontario-footer__link" href="https://www.ontario.ca/page/terms-use">
                        {{ 'terms.of.use' | translate | async}}
                    </a>
                </li>
				<li>
					<a class="ontario-footer__link" href="https://www.ontario.ca/feedback/contact-us?id=26932&nid=536826">
                        {{ 'footer.contact.us.link.text' | translate | async}}
					</a>
				</li>
            </ul>
            <div class="ontario-footer__copyright">
                <a class="ontario-footer__link" href="https://www.ontario.ca/page/copyright-information">
					{{ 'footer.copyright.link.text' | translate | async}}{{ year }} {{ 'footer.partnership.text' | translate | async}}
				</a>
            </div>
        </div>
    </div>
</footer>